import { render, staticRenderFns } from "./VisitItem.vue?vue&type=template&id=4ed17912&"
import script from "./VisitItem.ts?vue&type=script&lang=ts&"
export * from "./VisitItem.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports